import type { PlanType, Sport } from '@painpal/contracts';
import type { ZoneModel } from '@painpal/core';

export const colors = {
  paper: '#f2eee6',
  paper2: '#e9e4da',
  ink: '#101b2c',
  pink: '#ef7899',
  hot: '#dd5278',
  green: '#7fb79a',
  amber: '#f0d264',
  line: '#101f3c38',
  textSecondary: '#647087',
  planEndurance: '#88abdf',
  planSweetSpot: '#f6e5a6',
  sportRun: '#1e767c',
  sportSwim: '#2d4e8c',
  sportWalk: '#8a5a3c',
  sportOther: '#616c83',
} as const;

export const alpha = {
  fitnessArea: '#101b2c12',
  elevationArea: '#101b2c18',
  powerArea: '#ef789966',
  zeroLine: '#101b2c55',
  freshBand: '#7fb79a33',
  productiveBand: '#f0d26440',
  overreachingBand: '#dd527833',
  planRegion: '#101b2c0a',
} as const;

// Canvas text has no CSS cascade: without a fallback stack it renders serif until DM Mono loads.
export const chartMono = "'DM Mono', ui-monospace, monospace";

export const HIGH_LOAD = 180;

// One scale for every zone model, in Zwift's order: zone N is always ZONE_COLORS[N - 1], whether power, HR or pace.
export const ZONE_COLORS = [
  '#b3b9c4',
  colors.planEndurance,
  colors.green,
  colors.amber,
  '#f2a57f',
  colors.hot,
  '#8f6bb3',
] as const;

export const PLAN_COLORS: Record<PlanType, string> = {
  rest: colors.paper2,
  recovery: ZONE_COLORS[0],
  endurance: ZONE_COLORS[1],
  tempo: ZONE_COLORS[2],
  'sweet-spot': colors.planSweetSpot,
  threshold: ZONE_COLORS[3],
  'vo2-max': ZONE_COLORS[4],
  race: ZONE_COLORS[5],
};

// Sports sit outside the zone scale on purpose: zones are pastels, sports (bar Ride's Load pink) are dark or neutral.
export const SPORT_COLORS: Record<Sport, string> = {
  ride: colors.pink,
  run: colors.sportRun,
  swim: colors.sportSwim,
  walk: colors.sportWalk,
  strength: colors.ink,
  other: colors.sportOther,
};

// The LTHR model splits zone 5 into 5a/5b/5c, so they get deepening shades of Z5 orange rather than Z6/Z7.
export const ZONE_PALETTES: Record<ZoneModel, readonly string[]> = {
  power: ZONE_COLORS,
  hr_max: ZONE_COLORS.slice(0, 5),
  pace: ZONE_COLORS.slice(0, 5),
  hr_lthr: [...ZONE_COLORS.slice(0, 5), '#e88a5e', '#d1703f'],
};
